// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#chatform .contents {\n  display: grid;\n  height: 100%;\n}", "",{"version":3,"sources":["webpack://./src/client/component/contents/Contents.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,YAAA;AACF","sourcesContent":["#chatform .contents {\n  display: grid;\n  height: 100%;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
